export interface Form<TRecord = any> {
  isSaving: boolean;
  value: Partial<TRecord>;
}
